import React from 'react';
import { t } from '../../../i18n';
import { logoutIcon } from '../../assets/index';
import UserAvatar from '../user-avatar';
import './styles.scss';

const ProfileMobileNavbar = ({ user, onLogout }) => {
  return (
    <>
      <div className="courses-header__profile-wrapper courses-header__profile-wrapper_mobile">
        <div className="courses-header__profile-icon-wrapper courses-header__profile-icon-wrapper_mobile">
          <UserAvatar photoUrl={user.photo} userName={user.name} className="courses-header__author-avatar_mobile" />
        </div>
        <div>
          <b>{user.name}</b>
          <p>{user.email}</p>
        </div>
      </div>
      <hr className="courses-header__sidebar-footer-divider" />
      <div className="courses-header__logout-wrapper courses-header__logout-wrapper_mobile" onClick={onLogout}>
        <img src={logoutIcon} alt="logout" />
        <b>{t('DIGITAL_COURSES.HEADER.LOGOUT')}</b>
      </div>
    </>
  );
};

export default ProfileMobileNavbar;
